import { defaultRegion } from "common/config";
import { atom } from "jotai";

export const filtersOpenAtom = atom<boolean>(false);
export const mapVisibleOnMobileAtom = atom<boolean>(true);
export const leftPanelExpandedAtom = atom<boolean>(true);

export const mobileListViewAtom = atom<boolean>(false);

export const venueDetailsOpenedAtom = atom<boolean>(false);
export const searchVenueAtom = atom<string>("");
export const mapCenterAtom = atom({
  lat: defaultRegion.latitude,
  lng: defaultRegion.longitude,
});
export const savedPlaceIdToViewAtom = atom<string>("");
export const savedPlaceByUserIdToViewAtom = atom<string>("");
export const savedPlaceSortByToViewAtom = atom<string>("");
export const savedPlaceIdToViewDataChangedAtom = atom<boolean>(false);
